<template>
  <div>
    <v-subheader v-if="title">{{ title }}</v-subheader>

    <v-card-text>
      <v-layout row>
        <v-flex class="pr-3">
          <v-slider
            :value="value"
            @input="updateValue"
            :max="maxVal"
            :min="minVal"
          ></v-slider>
        </v-flex>

        <v-flex shrink style="width: 60px">
          <v-text-field
            :value="value"
            disabled
            class="mt-0"
            hide-details
            single-line
            type="number"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
  </div>

</template>

<script>
    import { required } from 'vuelidate/lib/validators'

    export default {
      name: 'SizeSettings',
      props: {
        title: {
          type: String,
          default: ''
        },
        initialVal: {
          type: Number,
          default: 300
        },
        minVal: {
          type: Number,
          default: 50
        },
        maxVal: {
          type: Number,
          default: 1200
        },
        value: {
          type: Number,
          default: 300
        }
      },
      methods: {
        updateValue (ev) {
          this.$emit('input', ev)
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/SizeSettings.vue